'use strict'
class PrivacyPolicy {
    static accept() {
        document.querySelector('#tc-privacy-policy').style.display = 'none'
        document.cookie = `PRIVACY_POLICY=1; expires=${new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365).toGMTString()}; SameSite=Lax; path=/`
    }
}
window.TimeCity = window.TimeCity || {};
window.TimeCity.PrivacyPolicy = PrivacyPolicy;